import React from "react";
import { connect } from "react-redux";
import language from "../../../language/index.js";
import toastMessage from "../../../utils/toastMessage.js";
import api from "../../../utils/api";
import Input from "../../Input/Input.js";
import Button from "../../Button/Button.js";
import { getStorage } from "../../../utils/storage.js";
import Select from "../../Input/Select.js";
import bloodGroups from "../../../constants/bloodGroups.js";
import { fetchProductTypes } from "../../../utils/queries/productsType/index.js";

// eslint-disable-next-line no-unused-vars
let copyData = [];
// eslint-disable-next-line no-unused-vars

class NewRequest extends React.Component {
  state = {
    error: {},
    data: [],
    csvData: [],
    packages: [],
    user: {},
    productInStock: [],
    requestStock: "",
    volume: "",
    currentStock: "",
    modifieProductIndex: null,
    productTypes: [],
    productType: null,
  
    bloodGroup: null,
};

  componentDidMount = async () => {
    const user = await getStorage();
    // console.log(this.props.selectedData);

    if (this.props?.selectedData?._id) {
      this.setState({
        bloodGroup: this.props?.selectedData?.bloodGroup
          ? {
              label: this.props?.selectedData?.bloodGroup,
              value: this.props?.selectedData?.bloodGroup,
            }
          : null,
        productType: this.props?.selectedData?.productType
          ? {
              label: this.props?.selectedData?.productType?.name,
              value: this.props?.selectedData?.productType?._id,
            }
          : null,
        currentStock: this.props?.selectedData?.currentStock || 0,
        requestStock: this.props?.selectedData?.toBeRequested || 0,
        volume: this.props?.selectedData?.volume || "",
      });
    }

    this.setState({ user });
    this.getCurrentStock(true);

    if (!!this.props.isForNominative) {
      this.getNominativeProducts(true);
    }
  };

  getNominativeProducts = async (isFetchingProduct, search) => {
    try {
      this.setState({
        isLoading: isFetchingProduct,
      });

      const data = await fetchProductTypes(this.props.defaultLanguage, {
        inputType: "dropdown",
        q: search ? search : undefined,
        page: 1,
        limit: 100,
      });

      this.setState({
        isLoading: false,
        allProducts: data,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  getCurrentStock = async (isLoading) => {
    try {
      this.setState({ isLoading });

      const allowedIds = (this.props.productType || []).map((el) =>
        typeof el === "object" ? el._id || el : el
      );

      const allTypes = await fetchProductTypes(this.props.defaultLanguage, {
        inputType: "dropdown",
      });

      const productInStock = (allTypes || [])
        .filter((el) => allowedIds.length === 0 || allowedIds.includes(el._id || el.value))
        .map((el) => ({
          label: el.label || el.name,
          value: el.value || el._id,
        }));

      this.setState({
        productInStock,
        productTypes: productInStock,
        isLoading: false,
      });
    } catch (error) {
      this.setState({ isLoading: false });

      toastMessage("error", error);
      console.log(error);
    }
  };

  returnFilters() {
    const { requestId } = this.props;
    return {
      id: requestId,
    };
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState(
      {
        [field]: e?.target
          ? e?.target?.value
          : field === "productType"
          ? { ...e, currentStock: e?.currentStock || 0 }
          : e,
        error,
      },
      () => {
        if (field === "productType" || field === "bloodGroup") {
          this.handleSearch();
        }
      }
    );
  }

  handleSearch() {
    const { productType, bloodGroup } = this.state;

    if (!bloodGroup || !productType) return;

    // for (let el of copyData) {
    //   if (
    //     el?.productType?._id === productType.value &&
    //     bloodGroup.value === el?.bloodGroup
    //   ) {
    //     this.setState({
    //       selectedProduct: { ...el, currentStock: el?.currentStock || 0 },
    //       requestStock: el?.diff || 0,
    //     });
    //   }
    // }
  }

  validateForm() {
    let { error, productType, requestStock, bloodGroup } = this.state;

    if (!productType) {
      error.productType =
        language[this.props.defaultLanguage].product_type_required;
    }

    if (!requestStock) {
      error.requestStock =
        language[this.props.defaultLanguage].request_stock_required;
    }

    if (!bloodGroup) {
      error.bloodGroup =
        language[this.props.defaultLanguage].blood_group_required;
    }

    console.log(error);

    this.setState({ error });
  }

  onSubmit = async () => {
    try {
      let requiredBody = {},
        method = "POST",
        { selectedProduct, productType, bloodGroup, error } = this.state;

      await this.validateForm();

      if (Object.keys(error).length > 0) return;

      this.setState({ isSubmitting: true });

      requiredBody = {
        type: this.props.isForNominative ? "nominative" : "bulk",
        request: this.props.request,
        productType: productType.value,
        numberOfPackages: this.state.requestStock,
        bloodGroup: bloodGroup.value,
        currentStock: this.state.currentStock || selectedProduct?.currentStock,
        toBeRequested: this.state.requestStock || selectedProduct?.diff,
        volume: this.state.volume !== "" ? Number(this.state.volume) : undefined,
      };

      if (this.props.selectedData?._id) {
        method = "PUT";
        requiredBody.id = this.props.selectedData?._id;
      }

      if (!!this.props.isForNominative) {
      }

      const options = {
        method,
        url: `${process.env.REACT_APP_BBMS_BASE_API}/product-request`,
        data: requiredBody,
      };

      await api(options);

      this.setState({
        isSubmitting: false,
        selectedData: {},
        bloodGroup: null,
        currentStock: 0,
        requestStock: "",
        volume: "",
        isRefresh: false,
      });

      toastMessage(
        "success",
        language[this.props.defaultLanguage].data_added_success
      );

      this.props.getData && this.props.getData();

      // !!this.props.getData && window.location.reload(true);

      if (this.props.selectedData?._id) {
        this.props.handleClose && this.props.handleClose();
      }
    } catch (error) {
      this.setState({
        isSubmitting: false,
        selectedData: {},
        isRefresh: false,
      });

      toastMessage("error", error);
    }
  };

  handleNotifyReceiver = async () => {
    try {
      let method = "POST";

      this.setState({
        isSendingReminder: true,
      });

      const options = {
        method,
        url: `${process.env.REACT_APP_BBMS_BASE_API}/bloodRequest/notification`,
        data: {
          requestNo: this.props.requestInfo?.requestNo,
          origin: this.props.requestInfo?.hospital?.name,
        },
      };

      await api(options);

      this.setState({
        isSendingReminder: false,
      });

      toastMessage(
        "success",
        language[this.props.defaultLanguage].notification_send_success
      );
    } catch (error) {
      toastMessage("error", error);

      this.setState({
        isSendingReminder: false,
      });
    }
  };

  render() {
    return (
      <>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Select
                options={
                  this.props.isForNominative
                    ? this.state.allProducts
                    : this.state.productInStock
                }
                label={language[this.props.defaultLanguage].product_type}
                placeholder={language[this.props.defaultLanguage].select}
                value={this.state.productType}
                onChange={(e) => this.onChangeText("productType", e)}
                error={this.state.error.productType}
              />
            </div>
            <div className="col-md-12">
              <Select
                options={bloodGroups}
                label={language[this.props.defaultLanguage].blood_group}
                placeholder={language[this.props.defaultLanguage].select}
                value={this.state.bloodGroup}
                onChange={(e) => this.onChangeText("bloodGroup", e)}
                error={this.state.error.bloodGroup}
              />
            </div>
            {/* <div className="col-md-12">
              <Input
                label={language[this.props.defaultLanguage].current_stock}
                placeholder={language[this.props.defaultLanguage].current_stock}
                value={this.state?.productType?.currentStock}
                onChange={(e) => this.onChangeText("currentStock", e)}
                error={this.state.error.currentStock}
                disabled
                type="number"
              />
            </div> */}
            <div className="col-md-12">
              <Input
                label={`${language[this.props.defaultLanguage].volume} (ml)`}
                placeholder="e.g. 450"
                value={this.state?.volume}
                onChange={(e) => this.onChangeText("volume", e)}
                error={this.state.error.volume}
                type="number"
              />
            </div>
            <div className="col-md-12">
              <Input
                label={language[this.props.defaultLanguage].request_stock}
                placeholder={language[this.props.defaultLanguage].request_stock}
                value={this.state?.requestStock}
                onChange={(e) => this.onChangeText("requestStock", e)}
                error={this.state.error.requestStock}
                type="number"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].close}
            onPress={this.props.handleClose}
            className="btn-default"
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            onPress={() => this.onSubmit()}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewRequest);
